import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../Workspaces/scss/BoardCalendarView.scss';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Mirrors the real BoardCalendarView layout so the loading state matches the
// selected view (month grid) instead of flashing the kanban skeleton.
const SkeletonCalendarView = () => (
    <div className="board-calendar">
        <div className="board-calendar__main">
            <div className="board-calendar__header">
                <div className="board-calendar__nav">
                    <Skeleton height={30} width={30} style={{ borderRadius: 6 }} />
                    <Skeleton height={20} width={150} style={{ borderRadius: 4 }} />
                    <Skeleton height={30} width={30} style={{ borderRadius: 6 }} />
                </div>
                <Skeleton height={30} width={64} style={{ borderRadius: 999 }} />
            </div>

            <div className="board-calendar__weekdays">
                {WEEKDAYS.map((d) => (
                    <div key={d} className="board-calendar__weekday">{d}</div>
                ))}
            </div>

            <div className="board-calendar__grid">
                {[...Array(6)].map((_, wi) => (
                    <div className="board-calendar__week" key={wi}>
                        <div className="board-calendar__day-cells">
                            {[...Array(7)].map((__, di) => (
                                <div className="board-calendar__day" key={di}>
                                    <Skeleton height={12} width={16} style={{ borderRadius: 3 }} />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default SkeletonCalendarView;
